import { Profile } from 'model/User'
import { OnRequestChangeCallback } from 'services/APIs/BaseAPI'
import { InternalAPI } from 'services/APIs/InternalAPI/InternalAPI'
import {
  GetWorkspaceResponse,
  SendActivationEmailRequest,
  UserDto,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { IUserAPI } from './PartyAccessController'

export class UserAPI extends InternalAPI implements IUserAPI {
  constructor(private onRequestChange: OnRequestChangeCallback) {
    super('/api', onRequestChange)
  }

  public async GetProfile() {
    return await this.GetAuthenticatedAsync<UserDto>({
      relativePath: '/user',
      id: 'get-profile',
    })
  }

  public async SaveProfile(profile: Profile) {
    return await this.PutAsync<UserDto>({
      relativePath: '/user',
      data: profile,
      id: 'save-profile',
    })
  }

  public async SendActivationEmail(req: SendActivationEmailRequest) {
    return await this.PostAsync<void>({
      id: 'send-activation-email',
      relativePath: '/user/SendActivationEmail',
      data: req,
    })
  }

  public async GetWorkspaceDetails(partyId: string) {
    return await this.GetAsync<GetWorkspaceResponse>({
      relativePath: `/parties/${partyId}/configuration`,
      id: 'get-workspace-configuration',
      retryOnTimeout: true,
    })
  }
}
